import { useState, useEffect } from 'react';
import { useDataTableContext } from 'src/components/DataTable/components/DataTableProvider/hooks/useDataTableContext';

export type UseDataTableSearchReturn = {
  query: string;
  setQuery: (query: string) => void;
  submit: (query: string) => void;
};

export const useDataTableSearch = (): UseDataTableSearchReturn => {
  const { tableState, setQuery: submitQuery } = useDataTableContext();
  const { query: contextQuery } = tableState;
  const [searchQuery, setSearchQuery] = useState(contextQuery ?? '');

  useEffect(() => {
    setSearchQuery(contextQuery ?? '');
  }, [contextQuery]);

  return {
    query: searchQuery,
    setQuery: setSearchQuery,
    submit: submitQuery,
  };
};
